// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent {
  display: grid;
  grid-template-columns: 1fr repeat(1, 9fr);
  grid-template-rows: repeat(1, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

/* Estilos para dispositivos grandes */
@media (min-width: 851px) {
  .div1 {
    display: flex;
    flex-direction: column;
    height: 70%;
    margin-top: 50%;
  }
}

/* Estilos para dispositivos móviles */
@media (max-width: 850px) {
  .parent {
    display: flex;
  }

  .div1 {
    display: none;
  }
}

.div1 img {
  margin: 5px 5px 10px 10px;
  border: 1px solid #73879c !important;
  border-radius: 50%;
  padding: 5px;
  background-color: #fff;
  cursor: pointer;
}

.board {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  width: 100%;
  height: 100%;
}

.cont-panel {
  display: inline-block;
  width: 100%;
  padding: 10px 17px;
  background: #fff;
  border-bottom: 1px solid #e6e9ed;
  -webkit-column-break-inside: avoid;
  -moz-column-break-inside: avoid;
  opacity: 1;
  transition: all 0.2s ease;
}

.panel {
  padding: 1px 5px 6px;
}

.panel h6 {
  margin: 5px 0 6px;
  float: left;
  display: block;
}

.panel_toolbox {
  float: right;
  min-width: 70px;
}

.panel_toolbox li i {
  cursor: pointer;
  padding: 5px;
  color: #c5c7cb;
  font-size: 14px;
}

.panel_toolbox li i:hover {
  color: #9bbcdf;
}

.cont-colldown {
  margin: auto;
  color: rgba(235, 124, 220, 0.993);
  height: 100%;
}

.dropzone {
  width: 100%;
  margin: 0 2%;
  max-height: 60px;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dropzone-active {
  background-color: #e1e9f1;
  border: 1px solid rgb(146, 146, 223);
  border-radius: 5px;
}

.btn-dropC {
  display: flex;
  color: #fff;
  background-color: rgb(150, 191, 243);
  border: 1px solid rgb(123, 169, 230);
  border-radius: 5px;
  margin-left: 1%;
  padding-left: 10px;
  cursor: pointer;
}

.btn-dropC:active {
  color: black;
}

.btn-cancelDrop {
  margin-left: 5px;
  border: none;
  background-color: rgb(129, 173, 231);
  font-weight: 600;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: inset 0px 0px 9px 1px rgba(0, 0, 0, 0.35);
}

.type-company {
  background-color: rgb(185, 231, 125);
  border: 1px solid rgb(124, 170, 64);
}

.cancel-type-company {
  background-color: rgb(156, 202, 95);
}

.type-branch {
  background-color: rgb(247, 180, 126);
  border: 1px solid rgb(180, 121, 73);
}

.cancel-type-branch {
  background-color: rgb(206, 131, 70);
}

.type-place {
  background-color: rgb(140, 240, 235);
  border: 1px solid rgb(55, 160, 155);
}

.cancel-type-place {
  background-color: rgb(82, 212, 206);
}

.type-zone {
  background-color: rgb(231, 171, 211);
  border: 1px solid rgb(170, 83, 141);
}

.cancel-type-zone {
  background-color: rgb(202, 139, 181);
}

.type-local {
  background-color: rgb(233, 231, 142);
  border: 1px solid rgb(184, 182, 69);
}

.cancel-type-local {
  background-color: rgb(219, 217, 106);
}

.selected-drag {
  box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.52);
  -webkit-box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.52);
  transform: scale(1.05);
}

.info-zonedrop {
  margin: 2% 2%;
}

.inpt-board {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3%;
}

.inpt-board input {
  width: 45%;
}

.filterChart {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 90%;
  margin: auto;
}

.filterChart .form-filter {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3%;
}

.filterChart .form-filter select {
  width: 45%;
}

.modal-content {
  border-radius: 0;
}

.modal-header {
  border-radius: 0;
}

.modal-footer {
  border-radius: 0;
}

.modal-body {
  border-radius: 0;
}

.option-widget {
  cursor: pointer;
  margin-bottom: 5px;
  width: 90px;
}

.option-widget:hover {
  cursor: pointer;
  background-color: #c3ddf3;
  color: #466881;
}

.option-widget {
  text-decoration: none;
  color: #73879c;
  cursor: pointer;
}

.option-widget a {
  text-decoration: none;
  color: #73879c;
}

.cont-template {
  margin-bottom: 5%;
}

.template-bar {
  background-color: #e8e7e7c8;
  border: 1px solid #d4d4d4;
  margin: auto;
}

.template-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.template-title p {
  margin: 1% 3%;
  font-size: 20px;
}

.template-bar button {
  font-size: 13px;
  color: #73879c;
  background-color: transparent;
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 5px;
  margin-right: 25px;
}

.template-bar button:hover {
  background-color: #c3c6c9;
}

.template-bar i {
  margin-right: 5px;
}

.template-filters p {
  margin: 0 3%;
  font-size: 13px;
}

.btn-reportDisable {
  display: flex;
  align-items: center;
  gap: 5px;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/DashboardSelected.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAE/B,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,uDAAuD;EACvD,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".parent {\n  display: grid;\n  grid-template-columns: 1fr repeat(1, 9fr);\n  grid-template-rows: repeat(1, 1fr);\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n}\n\n/* Estilos para dispositivos grandes */\n@media (min-width: 851px) {\n  .div1 {\n    display: flex;\n    flex-direction: column;\n    height: 70%;\n    margin-top: 50%;\n  }\n}\n\n/* Estilos para dispositivos móviles */\n@media (max-width: 850px) {\n  .parent {\n    display: flex;\n  }\n\n  .div1 {\n    display: none;\n  }\n}\n\n.div1 img {\n  margin: 5px 5px 10px 10px;\n  border: 1px solid #73879c !important;\n  border-radius: 50%;\n  padding: 5px;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.board {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(1, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 0px;\n  width: 100%;\n  height: 100%;\n}\n\n.cont-panel {\n  display: inline-block;\n  width: 100%;\n  padding: 10px 17px;\n  background: #fff;\n  border-bottom: 1px solid #e6e9ed;\n  -webkit-column-break-inside: avoid;\n  -moz-column-break-inside: avoid;\n  opacity: 1;\n  transition: all 0.2s ease;\n}\n\n.panel {\n  padding: 1px 5px 6px;\n}\n\n.panel h6 {\n  margin: 5px 0 6px;\n  float: left;\n  display: block;\n}\n\n.panel_toolbox {\n  float: right;\n  min-width: 70px;\n}\n\n.panel_toolbox li i {\n  cursor: pointer;\n  padding: 5px;\n  color: #c5c7cb;\n  font-size: 14px;\n}\n\n.panel_toolbox li i:hover {\n  color: #9bbcdf;\n}\n\n.cont-colldown {\n  margin: auto;\n  color: rgba(235, 124, 220, 0.993);\n  height: 100%;\n}\n\n.dropzone {\n  width: 100%;\n  margin: 0 2%;\n  max-height: 60px;\n  height: 45px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.dropzone-active {\n  background-color: #e1e9f1;\n  border: 1px solid rgb(146, 146, 223);\n  border-radius: 5px;\n}\n\n.btn-dropC {\n  display: flex;\n  color: #fff;\n  background-color: rgb(150, 191, 243);\n  border: 1px solid rgb(123, 169, 230);\n  border-radius: 5px;\n  margin-left: 1%;\n  padding-left: 10px;\n  cursor: pointer;\n}\n\n.btn-dropC:active {\n  color: black;\n}\n\n.btn-cancelDrop {\n  margin-left: 5px;\n  border: none;\n  background-color: rgb(129, 173, 231);\n  font-weight: 600;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  -webkit-box-shadow: inset 0px 0px 9px 1px rgba(0, 0, 0, 0.35);\n  box-shadow: inset 0px 0px 9px 1px rgba(0, 0, 0, 0.35);\n}\n\n.type-company {\n  background-color: rgb(185, 231, 125);\n  border: 1px solid rgb(124, 170, 64);\n}\n\n.cancel-type-company {\n  background-color: rgb(156, 202, 95);\n}\n\n.type-branch {\n  background-color: rgb(247, 180, 126);\n  border: 1px solid rgb(180, 121, 73);\n}\n\n.cancel-type-branch {\n  background-color: rgb(206, 131, 70);\n}\n\n.type-place {\n  background-color: rgb(140, 240, 235);\n  border: 1px solid rgb(55, 160, 155);\n}\n\n.cancel-type-place {\n  background-color: rgb(82, 212, 206);\n}\n\n.type-zone {\n  background-color: rgb(231, 171, 211);\n  border: 1px solid rgb(170, 83, 141);\n}\n\n.cancel-type-zone {\n  background-color: rgb(202, 139, 181);\n}\n\n.type-local {\n  background-color: rgb(233, 231, 142);\n  border: 1px solid rgb(184, 182, 69);\n}\n\n.cancel-type-local {\n  background-color: rgb(219, 217, 106);\n}\n\n.selected-drag {\n  box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.52);\n  -webkit-box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.52);\n  -moz-box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.52);\n  transform: scale(1.05);\n}\n\n.info-zonedrop {\n  margin: 2% 2%;\n}\n\n.inpt-board {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3%;\n}\n\n.inpt-board input {\n  width: 45%;\n}\n\n.filterChart {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  width: 90%;\n  margin: auto;\n}\n\n.filterChart .form-filter {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3%;\n}\n\n.filterChart .form-filter select {\n  width: 45%;\n}\n\n.modal-content {\n  border-radius: 0;\n}\n\n.modal-header {\n  border-radius: 0;\n}\n\n.modal-footer {\n  border-radius: 0;\n}\n\n.modal-body {\n  border-radius: 0;\n}\n\n.option-widget {\n  cursor: pointer;\n  margin-bottom: 5px;\n  width: 90px;\n}\n\n.option-widget:hover {\n  cursor: pointer;\n  background-color: #c3ddf3;\n  color: #466881;\n}\n\n.option-widget {\n  text-decoration: none;\n  color: #73879c;\n  cursor: pointer;\n}\n\n.option-widget a {\n  text-decoration: none;\n  color: #73879c;\n}\n\n.cont-template {\n  margin-bottom: 5%;\n}\n\n.template-bar {\n  background-color: #e8e7e7c8;\n  border: 1px solid #d4d4d4;\n  margin: auto;\n}\n\n.template-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.template-title p {\n  margin: 1% 3%;\n  font-size: 20px;\n}\n\n.template-bar button {\n  font-size: 13px;\n  color: #73879c;\n  background-color: transparent;\n  text-decoration: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  padding: 5px;\n  margin-right: 25px;\n}\n\n.template-bar button:hover {\n  background-color: #c3c6c9;\n}\n\n.template-bar i {\n  margin-right: 5px;\n}\n\n.template-filters p {\n  margin: 0 3%;\n  font-size: 13px;\n}\n\n.btn-reportDisable {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: white;\n  font-weight: bold;\n  padding: 10px 20px;\n  border-radius: 5px;\n  border: none;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
